module.exports = __webpack_public_path__ + "static/media/ambrussum_pontamroix.be6006ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/ambrussum_pontamroix.png
// module id = 697
// module chunks = 0